// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify} from 'vuetify'

// export default createVuetify(
//   // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
// )

export default createVuetify({
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#F5F7Fa',
          primary: '#005B96', // #070F26
          'primary-lighten-1': '#327bab',
          'primary-lighten-2': '#669cc0',
          'primary-lighten-3': '#99bdd5',
          'primary-lighten-4': '#ccdeea',
          'primary-lighten-5': '#e5eef4',

          secondary: '#193AFC', // #005B96

          warning_lighten_1: '#EF5350', //  #EF5350
        },
      },  
    },
  },

  defaults: {
    VCard: {
      rounded: "xl", // This can be 0, xs, sm, true, lg, xl, pill, circle, and shaped
      variant: 'outlined',
      // elevation: "4",
    },
    VDialog: {
      VCard: {
        variant: 'elevated',
        elevation: "8",
      }
    },

  },
})
